import { render, staticRenderFns } from "./outboundconfirm.vue?vue&type=template&id=1f8b66c6&scoped=true"
import script from "./outboundconfirm.vue?vue&type=script&lang=ts"
export * from "./outboundconfirm.vue?vue&type=script&lang=ts"
import style0 from "./outboundconfirm.vue?vue&type=style&index=0&id=1f8b66c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8b66c6",
  null
  
)

export default component.exports